module.exports = __webpack_public_path__ + "static/media/loader.08102035.gif";